<template>
    <div>
        <div class="selectLanguage" @click="toggleSelect">
            <md-icon style="color: lightgray">language</md-icon>
        </div>
        <ul class="languageList" v-if="isSelectionTrue" @mouseleave="selectBlur">
            <li @click="languageSelect(lang.code)" v-for="lang in languages">{{ lang.name }}</li>
        </ul>
    </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import log2 from "../utils/log2";

const log = log2("LanguageSwitch");
export default {
    name: "LanguageSwitch",
    data() {
        return {
            isSelectionTrue: false,
        };
    },
    computed: {
        ...mapState({
            language: (state) => state.language.language,
            languages: (state) => state.language.languages,
        }),
    },
    methods: {
        ...mapActions({
            setLanguage: "language/setLanguage",
        }),
        toggleSelect() {
            log("togle select calıştı");
            this.isSelectionTrue = !this.isSelectionTrue;
        },
        selectBlur() {
            log("selectBlur calisti");
            this.isSelectionTrue = false;
        },
        languageSelect(code) {
            this.setLanguage(code);
            this.isSelectionTrue = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.selectLanguage {
    float: right;
    margin-top: 3rem;
    margin-right: 1.5rem;
    cursor: pointer;
}

.languageList {
    list-style: none;
    overflow: hidden;
    margin: 0;
    padding: 0;
    background: lightgray;
    color: #515173;
    display: inline-block;
    position: fixed;
    top: 10px;
    right: 20px;
    border-radius: 3px;

    li {
        cursor: pointer;
        user-select: none;
        padding: 6px 12px;

        &:hover {
            background-color: #06a9f3;
            color: white;
        }
    }
}
</style>
